module.exports = __webpack_public_path__ + "img/2a.52ec5f6f.png";